import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { SITE } from "@/data/site";

/** Fallback while loading / offline — mirrors the seeded default program so the page never renders empty. */
export const DEFAULT_PROGRAM = {
  id: null,
  title: "Kompletní detailing 4 v 1",
  subtitle: SITE.hero.sub,
  description: "",
  items: SITE.hero.bullets.map((b) => ({ label: b.label, price: Number(b.price.replace(/\D/g, "")) })),
  price: SITE.priceNumeric,
  regular_price_effective: 5300,
  savings: 5300 - SITE.priceNumeric,
  discount_pct: 43,
  location: "all",
  location_label: "Čestlice i Butovice",
  spots: 20,
};

export const fetchActivePrograms = async () =>
  (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/programs/active`)).data;

const Ctx = createContext({ program: DEFAULT_PROGRAM, byLocation: {}, programs: [], location: "cestlice", setLocation: () => {}, differs: false, loaded: false });

export function ProgramProvider({ children, initialLocation = "cestlice" }) {
  const [data, setData] = useState(null);
  const [location, setLocation] = useState(initialLocation);
  useEffect(() => { fetchActivePrograms().then(setData).catch(() => {}); }, []);
  const value = useMemo(() => {
    const byLocation = data?.by_location || {};
    const program = byLocation[location] || data?.programs?.[0] || DEFAULT_PROGRAM;
    const ids = Object.values(byLocation).filter(Boolean).map((p) => p.id);
    return { program, byLocation, programs: data?.programs || [], location, setLocation, differs: new Set(ids).size > 1, loaded: !!data };
  }, [data, location]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useProgram = () => useContext(Ctx);
